import { recentListingStatus } from '../_config';

export default {
    // 调用获取listing 接口 需要传递的参数
    listingParams(state, getters, rootState, rootGetters) {
        return {
            ...state.searchParams,
            siteId: rootGetters.siteId,
            listingStatus: state.currentListingStatus,
            page: state.pageNum,
            pageSize: state.pageSize
        };
    },
    // recent listing相关状态展示
    showRecentListingData(state, getters) {
        return (
            (state.fetchListingStatus === recentListingStatus.loading ||
                state.fetchListingStatus === recentListingStatus.loaded) &&
            !getters.showRecentListingNoData
        );
    },
    showRecentListingLoading(state) {
        return state.fetchListingStatus === recentListingStatus.loading;
    },
    showRecentListingNoLocation(state) {
        return state.fetchListingStatus === recentListingStatus.noLocation;
    },
    showRecentListingComing(state) {
        return state.fetchListingStatus === recentListingStatus.coming;
    },
    showRecentListingNoData(state) {
        return (
            state.fetchListingStatus !== recentListingStatus.coming &&
            state.fetchListingStatus !== recentListingStatus.noLocation &&
            state.listing.length === 0
        );
    },
    // 是否是sold listing
    isSoldListing(state) {
        return state.currentListingStatus.toLowerCase() === 'sold';
    }
};
